import forms from '@/sui/tools/forms'
import tools from '@/sui/tools/main'
import moment from 'moment'

function zeroToTen (f, m) {
  f.error = ''
  if (f.value === '') {
    f.error = `Aucune fréquence d'utilisation saisie.`
    return
  }

  const v = parseInt(f.value)
  if (v < 0 || v > 10) {
    f.error = 'La fréquence doit être comprise entre 1 et 10.'
  }
}

function checkIntField (item, min, max, unk) {
  return function (f, m) {
    f.error = ''
    if (f.value === '') {
      f.error = `Aucun ${item} saisi.`
      return
    }

    const v = parseInt(f.value)
    const allowUnknown = unk != null

    if ((allowUnknown && ((v < min || v > max) && v !== unk)) ||
        (!allowUnknown && (v < min || v > max))) {
      f.error =
          `Le nombre ${item} doit être situé entre 1 et 30${allowUnknown ? ' (99 si non connu)' : ''}.`
    }
  }
}

function limits (y) {
  return {
    bidt: {
      start: moment('01/01/1900', 'DD/MM/YYYY'),
      end: moment(`31/12/${y}`, 'DD/MM/YYYY')
    },

    epdt: {
      start: moment(`01/12/${parseInt(y) - 1}`, 'DD/MM/YYYY'),
      end: moment(`31/12/${y}`, 'DD/MM/YYYY')
    }
  }
}

function checkDate (d, l) {
  if (d.value === '') {
    d.error = `Aucune date saisie.`
  } else {
    const v = moment(d.value, 'DDMMYYYY')
    if (v.isBefore(l.start)) {
      d.error =
         `La date ne doit pas être antérieure au ${l.start.format('DD/MM/YYYY')}.`
    }

    if (v.isAfter(l.end)) {
      d.error =
        `La date ne doit pas être postérieure au ${l.end.format('DD/MM/YYYY')}.`
    }
  }
}

function checkDates (year) {
  const l = limits(year)
  return (f, m) => {
    m.bidt.error = ''
    m.epdt.error = ''
    checkDate(m.bidt, l.bidt)
    checkDate(m.epdt, l.epdt)

    const e = moment(m.epdt.value, 'DDMMYYYY')
    const b = moment(m.bidt.value, 'DDMMYYYY')
    if (b.isAfter(e)) {
      if (m.epdt.error === '') {
        m.epdt.error =
          `La date de l'épisode doit être postérieure à la date de naissance.`
      }
      if (m.bidt.error === '') {
        m.bidt.error =
          `La date de naissance doit être antérieure à la date de l'épisode.`
      }
    }
  }
}

function buildUnitFields (year) {
  const result = [
    forms.newField(
      'beds', 'NOMBRE DE LITS DU SERVICE', '', 'Nombre de lits', 'col-xs-12',
      (e, m) => {
        e.error = ''
        if (e.value === '') {
          e.error = 'Aucun nombre de lits saisi.'
          return
        }

        const nb = parseInt(e.value)
        if (nb <= 0) {
          e.error = 'Le service doit comporter au moins un lit.'
        } else if (nb >= 30) {
          e.error = 'Le service doit comporter au maximum trente lits.'
        }
      },
      {
        numeral: true,
        numeralIntegerScale: 2,
        numeralThousandsGroupStyle: 'none'
      },
      null,
      parseInt
    ),
    forms.newField(
      'cli', 'NOM ET PRÉNOM DU RÉANIMATEUR', '',
      `Nom et prénom du clinicien en charge de l'étude`, 'col-xs-12',
      'Aucun nom saisi.'
    ),
    forms.newField(
      'clie', 'E-MAIL DU RÉANIMATEUR', '',
      `Adresse e-mail du clinicien en charge de l'étude`, 'col-xs-12',
      (e, m) => {
        e.error = ''
        if (e.value === '') {
          e.error = 'Aucune adresse e-mail saisi.'
          return
        }

        if (!tools.isEmailValid(e.value)) {
          e.error = `L'adresse e-mail saisie est invalide.`
        }
      }
    ),
    forms.newYesNo(
      'chk', 'CHECKLIST',
      `Le service dispose d'une CHECKLIST pour la pose des cathéters centraux.`,
      null, 'col-xs-12 col-md-6'
    ),
    forms.newYesNo(
      'cvc', 'PROTOCOLE POUR LA POSE DES CVCs',
      `Le service dispose d'un protocole/procédure (validée par l'EOH ou
équivalent) pour la pose des CVCs.`
    )
  ]

  if (year >= '2022') {
    result.push(
      forms.newYesNoNCNA(
        'cvo', 'PROTOCOLE POUR LA POSE DES CVOs',
        `Le service dispose d'un protocole/procédure (validée par l'EOH ou
équivalent) pour la pose des CVOs.<br>Coder «9. NC/NA» si le service de réanimation
n'est pas un service de réanimation néonatale.`
      )
    )
  }

  result.push(
    forms.newYesNo(
      'picc', 'PROTOCOLE POUR LA POSE DES PICCLINES',
      `Le service dispose d'un protocole/procédure (validée par l'EOH ou
équivalent) pour la pose des PICClines.`
    ),
    forms.newYesNo(
      'mid', 'PROTOCOLE POUR LA POSE DES MIDLINES',
      `Le service dispose d'un protocole/procédure (validée par l'EOH ou
équivalent) pour la pose des MIDlines.`
    )
  )

  if (year >= '2022') {
    result.push(
      forms.newYesNoNCNA(
        'chg', 'UTILISATION DE CHG 2% POUR LA POSE DES CATHÉTERS CENTRAUX',
        `Le service dispose de la Chlorhexidine alcoolique à 2% pour la pose
des cathéters centraux.<br>Coder «9. NC/NA» pour les services de réanimation
néonatale.`
      )
    )
  } else {
    result.push(
      forms.newYesNo(
        'chg', 'UTILISATION DE CHG 2% POUR LA POSE DES CATHÉTERS CENTRAUX',
        `Le service dispose de la Chlorhexidine alcoolique à 2% pour la pose
des cathéters centraux.`
      )
    )
  }

  result.push(
    forms.newYesNo(
      'chga', 'AVEC APPLICATEUR ?', '',
      (m) => m.chg.value === 1
    ),
    forms.newYesNo(
      'pad', `PANSEMENTS OCCLUSIFS, STÉRILES ET TRANSPARENTS POUR LA POSE DES
CATHÉTERS CENTRAUX`,
      `Le service dispose de pansements occlusifs, stériles et transparents
pour la pose des cathéters centraux.`
    ),
    forms.newYesNo(
      'padr', 'PROTOCOLE DE RÉFECTION DES PANSEMENTS',
      `Le service dispose d'un protocole/procédure (validée par l'EOH ou
équivalent) pour la réfection des pansements des cathéters centraux.`
    ),
    forms.newYesNo(
      'ctn', 'PROTOCOLE DE BRANCHEMENT',
      `Le service dispose d'un protocole/procédure (validée par l'EOH ou
équivalent) pour la gestion des lignes des cathéters centraux.`
    ),
    forms.newYesNo(
      'obs', 'OBSERVATION DES PRATIQUES',
      `Les pratiques de pose et/ou de manipulation des dispositifs
intra-vasculaires ont fait l'objet d'une observation des pratiques dans le
service au cours des 12 derniers mois.`
    ),
    forms.newYesNo(
      'less', 'FORMATION',
      `Les pratiques de pose et/ou de manipulation des dispositifs
intra-vasculaires ont fait l'objet d'une formation dans le service au cours des
12 derniers mois.`
    ),
    forms.newYesNo(
      'ikt', 'CATHÉTERS IMPRÉGNÉS',
      `Les cathéters imprégnés ont été utilisés dans le service au cours
des 12 derniers mois.`
    ),
    forms.newField(
      'iktt', 'TYPE DE CATHÉTER IMPRÉGNÉ', '', 'Type de cathéter imprégné',
      'col-xs-12 col-md-6', 'Aucun type de cathéter imprégné saisi.', null,
      (m) => m.ikt.value === 1
    ),
    forms.newField(
      'iktf', `FRÉQUENCE D'UTILISATION`,
      'De 0 (rare) à 10 (systématique)', 'De 0 (rare) à 10 (systématique)',
      'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.ikt.value === 1, parseInt
    ),
    forms.newYesNo(
      'ipd', 'PANSEMENTS IMPRÉGNÉS DE PRODUITS ANTI-MICROBIENS',
      `Les pansements imprégnés ont été utilisés dans le service au cours des
12 derniers mois`
    ),
    forms.newField(
      'ipdt', 'TYPE DE PANSEMENT IMPRÉGNÉ', '', 'Type de pansement imprégné',
      'col-xs-12 col-md-6', 'Aucun type de pansement imprégné saisi.', null,
      (m) => m.ipd.value === 1
    ),
    forms.newField(
      'ipdf', `FRÉQUENCE D'UTILISATION`,
      'De 0 (rare) à 10 (systématique)', 'De 0 (rare) à 10 (systématique)',
      'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.ipd.value === 1, parseInt
    ),
    forms.newYesNo(
      'isp', 'ÉPONGES IMPRÉGNÉES DE PRODUITS ANTI-MICROBIENS',
      `Les éponges imprégnées ont été utilisées dans le service au cours des
12 derniers mois`
    ),
    forms.newField(
      'ispt', `TYPE D'ÉPONGE IMPRÉGNÉE`, '', `Type d'éponge imprégnée`,
      'col-xs-12 col-md-6', `Aucun type d'éponge imprégnée saisi.`, null,
      (m) => m.isp.value === 1
    ),
    forms.newField(
      'ispf', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
      'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.isp.value === 1, parseInt
    ),
    forms.newYesNo(
      'ict', 'CONNECTIQUE',
      `Des bouchons, connecteurs, valves imprégnées (antibiotiques,
anticoagulant, ...) ont été utilisés dans le service au cours des 12 derniers
mois.`
    ),
    forms.newField(
      'ictt', `TYPE DE DISPOSITIF`, '', `Type de dispositif`,
      'col-xs-12 col-md-6', `Aucun type de dispositif saisi.`, null,
      (m) => m.ict.value === 1
    ),
    forms.newField(
      'ictf', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
      'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.ict.value === 1, parseInt
    )
  )

  if (year >= '2023') {
    result.push(
      forms.newYesNo(
        'edl',
        `DISPOSITIF DE PERFUSION MULTI-LUMIÈRES TYPE EDELVAISS-MULTILINE®`,
        `Des dispositifs de perfusion type Edelvaiss-multiline ont été utilisés dans le
service au cours des 12 derniers mois.`
      ),
      forms.newField(
        'edlt', `TYPE DE DISPOSITIF`, '', `Type de dispositif`,
        'col-xs-12 col-md-6', `Aucun type de dispositif saisi.`, null,
        (m) => m.edl.value === 1
      ),
      forms.newField(
        'edlf', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
        'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
        { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
        (m) => m.edl.value === 1, parseInt
      ),
      forms.newField(
        'edld', 'DURÉE MOYENNE DU MAINTIEN (OPTIONNEL)', 'En jours', 'Durée moyenne du maintien',
        'col-xs-12', () => true,
        { numericOnly: true, blocks: [3], numeralThousandsGroupStyle: 'none' },
        (m) => m.edl.value === 1, parseInt, true
      )
    )
  }

  result.push(
    forms.newYesNo(
      'ist', 'SYSTÈME DE STABILISATION DES CATHÉTERS (SUTURE-free)',
      `Des systèmes de stabilisation ont été utilisés dans le service au cours
des 12 derniers mois.`
    ),
    forms.newField(
      'istt', `TYPE DE STABILISATEUR`, '', `Type de stabilisateur`,
      'col-xs-12 col-md-6', `Aucun type de stabilisateur saisi.`, null,
      (m) => m.ist.value === 1
    ),
    forms.newField(
      'istf', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
      'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.ist.value === 1, parseInt
    ),
    forms.newYesNo(
      'ilo', 'VERROUS',
      `Des verrous (antibiotiques, anticoagulant) ont été utilisés dans le
service au cours des 12 derniers mois.`
    ),
    forms.newField(
      'ilot', `TYPE DE VERROU`, '', `Type de verrou`,
      'col-xs-12 col-md-6', `Aucun type de verrou saisi.`, null,
      (m) => m.ilo.value === 1
    ),
    forms.newField(
      'ilof', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
      'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.ilo.value === 1, parseInt
    ),
    forms.newYesNo(
      'iwa', `TOILETTE DES PATIENTS AVEC UNE SOLUTION DE CHLOREXIDINE`,
      `La toilette des patients avec la CHG est réalisée dans le service.`
    ),
    forms.newField(
      'iwat', `EN MOYENNE, COMBIEN DE TOILETTES À LA CHG SONT-ELLES EFFECTUÉES PAR SEMAINE POUR UN PATIENT ?`,
      `Sur une semaine, combien de toilettes à la CHG par patient ont-elles effectuées ?`,
      `Sur une semaine, combien de toilettes à la CHG par patient ont-elles effectuées ?`,
      'col-xs-12 col-md-6',
      checkIntField(
        'moyen de toilette',
        1, 30, 99
      ),
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.iwa.value === 1, parseInt
    ),
    forms.newField(
      'iwaf', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
      'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.iwa.value === 1, parseInt
    ),
    forms.newYesNo(
      'ioi', `POMMADE ANTIBIOTIQUE AU NIVEAU DU SITE D'ACCÈS`,
      `Une pommade antibiotique est appliquée au point d'insertion du
cathéter dans le service.`
    ),
    forms.newField(
      'ioit', `ANTIBIOTIQUE`, '', `Antibiotique utilisé`,
      'col-xs-12 col-md-6', `Aucun antibiotique saisi.`, null,
      (m) => m.ioi.value === 1
    ),
    forms.newField(
      'ioif', `FRÉQUENCE D'UTILISATION`, 'De 0 (rare) à 10 (systématique)',
      'De 0 (rare) à 10 (systématique)', 'col-xs-12 col-md-6', zeroToTen,
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.ioi.value === 1, parseInt
    )
  )
  return result
}

function buildPatientFields (year) {
  const result = [
    forms.newDate(
      'bidt', 'DATE DE NAISSANCE DU PATIENT', '',
      checkDates(year)
    ),
    forms.newChoices(
      'sex', 'SEXE DU PATIENT', '',
      [
        { key: 'masc', label: 'MASCULIN', value: 1 },
        { key: 'fem', label: 'FÉMININ', value: 2 },
        { key: 'aut', label: 'AUTRE', value: 3 },
        { key: 'nc', label: 'NON CONNU', value: 9 }
      ]
    ),
    forms.newDate(
      'epdt', `DATE DE L'ÉPISODE`,
      `Renseigner la date de <strong><u>réalisation</u></strong> de
l'hémoculture positive à <i>S. aureus</i>.`,
      checkDates(year)
    )
  ]

  const toilet = [
    forms.newYesNo(
      'iwa',
      `TOILETTE AVEC UNE SOLUTION DE CHLOREXIDINE DANS LES 7J AVANT L'ÉPISODE`,
      ``
    ),
    forms.newField(
      'iwat',
      `EN MOYENNE, COMBIEN DE TOILETTES À LA CHG SONT-ELLES EFFECTUÉES PAR SEMAINE POUR CE PATIENT ?`,
      ``, '',
      'col-xs-12',
      checkIntField(
        'moyen de toilette',
        1, 30, 99
      ),
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      (m) => m.iwa.value === 1, parseInt
    )
  ]

  let ifCVC = (m) => true
  if (year >= '2022') {
    result.push(
      ...toilet,
      forms.newYesNo(
        'ifkt', `PORT D'UN CATHETER CENTRAL OU ASSIMILÉ`,
        `Renseigner si le patient porte ou a porté un cathéter central ou assimilé (CVC,
CCI, CVO, PICC, MIDline avec prolongateur intégré, ECMO, cathéter de dialyse,
autre cathéter central) dans les 7 jours précédant le début de l'épisode
infectieux (date de la ponction de la première hémoculture positive à <i>S.
aureus</i>).`
      )
    )

    ifCVC = (m) => m.ifkt.value === 1
  }

  const chg = year === '2021' ? ' INFECTÉ, LE CAS ÉCHÉANT' : ''
  const padIf = year === '2021' ? (m) => m.pad.value === 1 : ifCVC
  result.push(
    forms.newYesNo(
      'chg',
      `UTILISATION DE CHG 2% POUR LA POSE DU CATHÉTER${chg}`,
      '', ifCVC
    ),
    forms.newYesNo(
      'pad', `PANSEMENT OCCLUSIF, STÉRILE ET TRANSPARENT`, '', ifCVC
    ),
    forms.newField(
      'padr', `NOMBRE DE RÉFECTION DE PANSEMENTS DEPUIS LA POSE`, '', '',
      'col-xs-12',
      checkIntField(
        'de réfection de pansements',
        0, 30, 99
      ),
      { numericOnly: true, blocks: [2], numeralThousandsGroupStyle: 'none' },
      padIf, parseInt
    ),
    forms.newYesNo(
      'ikt', 'CATHÉTER IMPRÉGNÉ', '', ifCVC
    ),
    forms.newField(
      'iktt', 'TYPE DE CATHÉTER IMPRÉGNÉ', '', '',
      'col-xs-12', 'Aucun type de cathéter imprégné saisi.', null,
      (m) => m.ikt.value === 1
    ),
    forms.newYesNo(
      'ipd', 'PANSEMENTS IMPRÉGNÉS DE PRODUITS ANTI-MICROBIENS', '', ifCVC
    ),
    forms.newField(
      'ipdt', 'TYPE DE PANSEMENT IMPRÉGNÉ', '', '',
      'col-xs-12', 'Aucun type de pansement imprégné saisi.', null,
      (m) => m.ipd.value === 1
    ),
    forms.newYesNo(
      'isp', 'ÉPONGES IMPRÉGNÉES DE PRODUITS ANTI-MICROBIENS', ``, ifCVC
    ),
    forms.newField(
      'ispt', `TYPE D'ÉPONGE IMPRÉGNÉE`, ``, '', 'col-xs-12',
      `Aucun type d'éponge imprégnée saisi.`, null,
      (m) => m.isp.value === 1
    ),
    forms.newYesNo(
      'ict', 'CONNECTIQUES IMPRÉGNÉES DE PRODUITS ANTIMICROBIENS (BOUCHONS, VALVES, ...)',
      ``, ifCVC
    ),
    forms.newField(
      'ictt', `TYPE DE DISPOSITIF`, ``, '', 'col-xs-12',
      `Aucun type de dispositif saisi.`, null, (m) => m.ict.value === 1
    )
  )

  if (year >= '2023') {
    result.push(
      forms.newYesNo(
        'edl',
        `DISPOSITIF DE PERFUSION MULTI-LUMIÈRES TYPE EDELVAISS-MULTILINE®`,
        `Des dispositifs de perfusion type Edelvaiss-multiline ont été utilisés dans le
service au cours des 12 derniers mois.`,
        ifCVC
      ),
      forms.newField(
        'edlt', `TYPE DE DISPOSITIF`, ``, '', 'col-xs-12',
        `Aucun type de dispositif saisi.`, null, (m) => m.edl.value === 1
      ),
      forms.newChoices(
        'edlm', 'DISPOSITIF EN PLACE DEPUIS', '',
        [
          { key: 'inf7', label: '<= 7 jours', value: 1 },
          { key: 'sup7', label: '> 7 jours', value: 2 },
          { key: 'nc', label: 'NON CONNU', value: 3 }
        ],
        (m) => m.edl.value === 1
      )
    )
  }

  result.push(
    forms.newYesNo(
      'ist', 'SYSTÈME DE STABILISATION DES CATHÉTERS (SUTURE-free)', ``, ifCVC
    ),
    forms.newField(
      'istt', `TYPE DE STABILISATEUR`, ``, '', 'col-xs-12',
      `Aucun type de stabilisateur saisi.`, null, (m) => m.ist.value === 1
    ),
    forms.newYesNo('ilo', 'VERROUS', ``, ifCVC),
    forms.newField(
      'ilot', `TYPE DE VERROU`, ``, '', 'col-xs-12', `Aucun type de verrou saisi.`,
      null, (m) => m.ilo.value === 1
    )
  )

  if (year === '2021') {
    result.push(...toilet)
  }

  result.push(
    forms.newYesNo(
      'ioi', `POMMADE ANTIBIOTIQUE AU NIVEAU DU SITE D'ACCÈS`, ``, ifCVC
    ),
    forms.newField(
      'ioit', `ANTIBIOTIQUE`, ``, '', 'col-xs-12', `Aucun antibiotique saisi.`, null,
      (m) => m.ioi.value === 1
    )
  )
  return result
}

export default {
  fields: [
    forms.newField(
      'firstName', 'Prénom du destinataire', '', 'Prénom', 'col-xs-12 col-md-6',
      'Aucun prénom saisi.'
    ),
    forms.newField(
      'name', 'Nom du destinataire', '', 'Nom', 'col-xs-12 col-md-6',
      'Aucun nom saisi.'
    ),
    forms.newField(
      'job', 'Fonction du destinataire', '', 'PH, infirmière hygiéniste, ...',
      'col-xs-12', 'Aucune fonction saisie.'
    ),
    forms.newField(
      'establishment', `Nom de l'établissement`, '', `Nom de l'établissement`,
      'col-xs-12', `Aucun nom d'établissement saisi.`
    ),
    forms.newField(
      'unit', 'Service', '', 'Service', 'col-xs-12', 'Aucun service saisi.'
    ),
    forms.newField(
      'address', 'Adresse précise', '', 'Adresse', 'col-xs-12',
      'Aucune adresse saisie.'
    ),
    forms.newField(
      'code', 'Code postal', '', 'Code postal', 'col-xs-12 col-md-6',
      (e, m) => {
        if (e.value === '') {
          e.error = 'Aucun code postal saisi.'
        } else if (e.value.length !== 5) {
          e.error = 'Le code postal doit contenir 5 chiffres.'
        } else {
          e.error = ''
        }
      },
      {
        numericOnly: true,
        blocks: [5],
        numeralThousandsGroupStyle: 'none'
      }
    ),
    forms.newField(
      'town', 'Ville', '', 'Ville', 'col-xs-12 col-md-6',
      'Aucune ville saisie.'
    )
  ],
  zeroToTen,
  unitFields: buildUnitFields,
  patientFields: buildPatientFields
}
